import { gql } from '@apollo/client';

export * from './escrowMembershipRemove.mutation.generated';

export const ESCROW_MEMBERSHIP_REMOVE = gql`
  mutation escrowMembershipRemove($escrowMembershipId: ID!) {
    escrowMembershipRemove(input: { escrowMembershipId: $escrowMembershipId }) {
      errors
      success
    }
  }
`;
